// листинг в каталоге

// import { createApp } from "vue";
import { createApp , ref , reactive } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js'

var detail_carousel_init = false;
var detail_carousel;

function InitDetailPageCarousel(){

    let el = document.querySelector( ".detail-left.f-carousel" );

    if( el ){
        if( window.innerWidth <= 1024 ){
            if( !detail_carousel_init ){
                detail_carousel_init = true;
                detail_carousel = new Carousel(
                    el ,
                    {
                        infinite : true ,
                        Dots : {
                            maxCount : 0
                        } ,
                    }
                );
            }
        }else if( detail_carousel_init ){
            detail_carousel.destroy();
            detail_carousel_init = false;
        }
    }
}

window.addEventListener( "resize" , InitDetailPageCarousel );
document.addEventListener( "DOMContentLoaded" , InitDetailPageCarousel );

function initDetailPageReactive(){

    const el = document.querySelector( '#detail-page-toggler' );
    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();
                    const model_size_id = ref( null );
                    const detail_error = ref( null );

                    function getVariants(){
                        let finded = Object.values( contextStore.data.detail ?? {} ).find( item => item.is_show );
                        return finded.variants ?? [];
                    }

                    function findModelSizeBySlug( slug ){
                        let temp;
                        for( let variant of getVariants() ){
                            temp = variant.values.find( item => item.slug === slug );
                            if( temp ){
                                return temp;
                            }
                        }
                    }

                    function isSelected( slug ){
                        return findModelSizeBySlug( slug )?.id === model_size_id.value;
                    }

                    function setModelSize( data ){
                        if( data ){
                            detail_error.value = '';
                            model_size_id.value = data;
                        }
                    }

                    let current_model_size = findModelSizeBySlug( contextStore.data.detail_slug );
                    if( current_model_size ){
                        setModelSize( current_model_size?.id );
                    }else{
                        for( let variant of getVariants() ){
                            if( variant.values.length === 1 ){
                                setModelSize( variant.values[ 0 ]?.id );
                                break;
                            }
                        }
                    }

                    async function incItemBasket(){

                        detail_error.value = '';

                        let variants = getVariants();

                        if( !model_size_id.value ){
                            if( getVariants().findIndex( item => item.values.length > 1 ) < 0 ){
                                model_size_id.value = variants[ 0 ].values[ 0 ].id;
                            }
                            if( !model_size_id.value ){
                                detail_error.value = 'выберите размер';
                            }
                        }

                        if( model_size_id.value ){
                            let answer = await contextStore.incItemBasket( model_size_id.value );
                            if( answer.error ){
                                detail_error.value = answer.error;
                            }
                        }
                    }

                    function getBasketCount( data ){
                        let el = contextStore.inBasket( data ? data : model_size_id.value );
                        return el ? el.count : null;
                    }

                    return {
                        contextStore ,
                        detail_error ,
                        getVariants ,
                        isSelected ,
                        setModelSize ,
                        incItemBasket ,
                        getBasketCount
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initDetailPageReactive );
